import { api } from "@/frontend/services/api";
import type {
  ApiResponse,
  SeasonQueryDTO,
  SeasonsPaginatedResponseDTO,
} from "@/shared/dto";

const BASE_URL = "/seasons/private";

export const seasonService = {
  getPaginate: (params?: SeasonQueryDTO) =>
    api.getWithParams<ApiResponse<SeasonsPaginatedResponseDTO>>(BASE_URL, params),
};
